import { render, staticRenderFns } from "./scopes-icon.vue?vue&type=template&id=d38908e0"
import script from "./scopes-icon.vue?vue&type=script&lang=ts"
export * from "./scopes-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports